import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/images/ever_logo_white.png'


const _hoisted_1 = { class: "bg-everBlack text-white py-12 px-5" }
const _hoisted_2 = { class: "flex md:flex-row flex-col" }
const _hoisted_3 = { class: "flex-1 flex" }
const _hoisted_4 = { class: "font-inter-semiBold text-base text-everWhite2 mb-3" }
const _hoisted_5 = { class: "flex flex-col text-14px text-everWhite1" }
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  style: {"width":"242px"},
  class: "flex flex-col justify-between md:mt-0 mt-16"
}
const _hoisted_8 = { class: "flex justify-between" }
const _hoisted_9 = ["href"]
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "text-everWhite1 text-14px mt-2.5" }, " Contact Us: marketing@ever.finance ", -1)
const _hoisted_12 = { class: "mt-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "flex items-center text-base" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      class: "w-6 h-6 mr-1",
      alt: "everVision logo"
    }),
    /*#__PURE__*/_createElementVNode("span", { class: "opacity-85" }, "everVision")
  ])
], -1)
const _hoisted_14 = { class: "text-everWhite1 text-12px mt-2" }

import { computed } from 'vue'
import Container from './Container.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const year = new Date().getFullYear()
const FooterEntries = computed(() => {
  return [
    {
      title: 'Products',
      items: [
        {
          title: 'everPay',
          link: 'https://app.everpay.io/'
        },
        {
          title: 'Permaswap',
          link: 'https://permaswap.network/'
        },
        {
          title: 'Web3Infra',
          link: 'https://web3infra.dev/'
        },
        {
          title: 'PermaDAO',
          link: 'https://permadao.com/'
        }
      ]
    },
    {
      title: 'Build',
      items: [
        {
          title: 'everPay.js',
          link: 'https://github.com/everFinance/everpay-js'
        },
        {
          title: 'Arseeding',
          link: 'https://web3infra.dev/docs/arseeding/introduction/lightNode'
        },
        {
          title: 'Goar',
          link: 'https://github.com/everFinance/goar'
        },
        {
          title: 'Arsyncer',
          link: 'https://github.com/everFinance/arsyncer'
        }
      ]
    },
    {
      title: 'Community',
      items: [
        {
          title: 'PermaDAO',
          link: 'https://permadao.com/'
        }
      ]
    }
  ]
})
const socials = [
  {
    link: 'https://news.ever.vision',
    name: 'medium'
  },
  {
    link: 'https://twitter.com/everVisionHQ',
    name: 'twitter'
  },
  {
    link: 'https://discord.gg/WM5MQZGVPF',
    name: 'discord'
  },
  {
    link: 'https://t.me/FinanceEver',
    name: 'telegram'
  },
  {
    link: 'https://github.com/everFinance',
    name: 'github'
  }
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Container, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(FooterEntries), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "flex-1"
              }, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(item.title), 1),
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.items, (links, linksIndex) => {
                    return (_openBlock(), _createElementBlock("a", {
                      key: linksIndex,
                      href: links.link,
                      target: "_blank",
                      class: "w-max mt-3 hover:text-everWhite2 transition-colors"
                    }, _toDisplayString(links.title), 9, _hoisted_6))
                  }), 128))
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(socials, (item, index) => {
                  return _createElementVNode("div", { key: index }, [
                    _createElementVNode("a", {
                      href: item.link,
                      target: "_blank",
                      class: "opacity-70 transition-opacity duration-300 hover:opacity-100"
                    }, [
                      _createElementVNode("img", {
                        src: require(`@/images/${item.name}.png`),
                        class: "w-5 h-5",
                        alt: item.name
                      }, null, 8, _hoisted_10)
                    ], 8, _hoisted_9)
                  ])
                }), 64))
              ]),
              _hoisted_11
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, " ©" + _toDisplayString(_unref(year)) + " everVision. All rights reserved ", 1)
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})